import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PagedResponse } from '../../core/model/pagination.model';
import { environment } from '../../environments/environment';
import { buildParams } from '../../rooms/services/rooms-api.service';
import {
  BookingChartTableRowDTO,
  BookingStatsDTO,
  CalculatedChartDataDTO,
  ChartSearchParams,
} from '../model/chart.model';

@Injectable({
  providedIn: 'root',
})
export class ChartDataApiService {
  readonly #http = inject(HttpClient);
  readonly #chartDataUrl = environment.user.roomBookingApi + '/charts';
  readonly #statsUrl = this.#chartDataUrl + '/stats';

  getCalculatedChartData(
    queryParams?: ChartSearchParams
  ): Observable<CalculatedChartDataDTO> {
    let params;
    if (queryParams) {
      params = buildParams(queryParams);
    }
    return this.#http.get<CalculatedChartDataDTO>(
      `${this.#chartDataUrl}/calculations`,
      {
        params,
      }
    );
  }

  getChartTableRows(
    queryParams?: ChartSearchParams,
    page = 0,
    pageSize = 10
  ): Observable<PagedResponse<BookingChartTableRowDTO>> {
    const params = buildParams({ ...queryParams, page, pageSize });
    return this.#http.get<PagedResponse<BookingChartTableRowDTO>>(
      `${this.#chartDataUrl}/table`,
      {
        params,
      }
    );
  }

  exportChartDataCsv(
    queryParams?: ChartSearchParams
  ): Observable<HttpResponse<Blob>> {
    let params;
    if (queryParams) {
      params = buildParams(queryParams);
    }

    return this.#http.get(`${this.#chartDataUrl}/csv`, {
      observe: 'response',
      responseType: 'blob',
      params,
    });
  }

  getBookingsStats(): Observable<BookingStatsDTO> {
    return this.#http.get<BookingStatsDTO>(this.#statsUrl);
  }
}
